module.exports = __webpack_public_path__ + "img/wl_prod2_2.076b543a.jpg";